import excepcionesConfig from "../data/excepciones-fechas.json";

const EMPTY_WINDOW = { dates: [], ranges: [] };

const normalizeWindow = (window) => ({
    dates: Array.isArray(window?.dates) ? window.dates : [],
    ranges: Array.isArray(window?.ranges) ? window.ranges : [],
});

const mergeWindows = (a, b) => ({
    dates: [...a.dates, ...b.dates],
    ranges: [...a.ranges, ...b.ranges],
});

const isInRanges = (dateStr, ranges) =>
    ranges.some((range) => dateStr >= range.start && dateStr <= range.end);

export const isDateInWindow = (dateStr, window) => {
    if (!dateStr) return false;
    const normalized = normalizeWindow(window || EMPTY_WINDOW);
    if (normalized.dates.includes(dateStr)) return true;
    return isInRanges(dateStr, normalized.ranges);
};

export const getExceptionsForSector = (sector) => {
    const globalConfig = excepcionesConfig?.global || {};
    const sectorConfig = (excepcionesConfig?.sectors || {})[sector] || {};

    const open = mergeWindows(
        normalizeWindow(globalConfig.open),
        normalizeWindow(sectorConfig.open)
    );
    const closed = mergeWindows(
        normalizeWindow(globalConfig.closed),
        normalizeWindow(sectorConfig.closed)
    );

    return {
        open,
        closed,
        camping: sectorConfig.camping || {},
    };
};

export const isDateForcedOpen = (dateStr, exceptions) =>
    isDateInWindow(dateStr, exceptions?.open);

export const isDateForcedClosed = (dateStr, exceptions) =>
    isDateInWindow(dateStr, exceptions?.closed);

export const isDateDisabled = ({
    date,
    dateStr,
    closedWeekdays,
    feriados,
    cerrado,
    exceptions,
}) => {
    const normalizedDateStr = dateStr || "";
    if (isDateForcedClosed(normalizedDateStr, exceptions)) return true;
    if (isDateForcedOpen(normalizedDateStr, exceptions)) return false;

    const isClosedByWeekday =
        closedWeekdays.includes(date.getDay()) && !feriados.includes(normalizedDateStr);
    const isClosedByDate = cerrado.includes(normalizedDateStr);

    return isClosedByWeekday || isClosedByDate;
};

export const getCampingWindowsForSector = (sector) => {
    const sectorConfig = (excepcionesConfig?.sectors || {})[sector] || {};
    const camping = sectorConfig.camping || {};

    return {
        entryOpen: normalizeWindow(camping.entryOpen),
        exitOpen: normalizeWindow(camping.exitOpen),
        entryClosed: normalizeWindow(camping.entryClosed),
        exitClosed: normalizeWindow(camping.exitClosed),
    };
};
